import createReducer from '../../lib/createReducer'

export default createReducer({
  item: null,
}, {})
